import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'

import TransparentPricingC from '@src/quince-components/src/atoms/transparentPricing'
import { buildTransparentPricingItems } from '@src/quince-components/src/atoms/transparentPricing/transparent-pricing.helpers'
import useStorefrontModeContext from '@src/quince-site-common/src/contexts/storefront-mode-context'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import B2BDivider from '@src/quince-site-common/src/organisms/b2b/b2b-divider'
import pdpStateManager from '@src/quince-site-common/src/redux/globalStateManager/PDPStateManager'
import { useAppSelector } from '@src/quince-site-common/src/redux/hooks'
import { ProductSectionType } from '@src/quince-site-pdp/src/types/productPage.types'

import ProductPageSectionProps from '../../../domains/ProductPageSectionProps'

import { shouldHideTransparentPricing } from './TransparentPricing'
import styles from './transparentPricing.module.scss'

const TransparentPricingProduct = (props: ProductPageSectionProps) => {
  const { t } = useTranslation('common')
  const transparentPricingSectionData = props.sectionData[ProductSectionType.TRANSPARENT_PRICING]
  const selectedOptions = useAppSelector<ProductVariantOption[]>(pdpStateManager, pdpStateManager.getSelectedOptions)

  const [quincePrice, setQuincePrice] = useState(transparentPricingSectionData.quincePrice)
  const [traditionalPrice, setTraditionalPrice] = useState(transparentPricingSectionData.traditionalPrice)

  const { isB2BMode } = useStorefrontModeContext()

  useEffect(() => {
    setQuincePrice(productHelper.getQuincePriceForOptions(props.product, selectedOptions))
    setTraditionalPrice(productHelper.getTraditionalPriceForOptions(props.product, selectedOptions) ?? 0)
  }, [selectedOptions, props.product])

  const costsForVariant = productHelper.getTransparentPricingCostsForProduct(
    props.product,
    selectedOptions,
    transparentPricingSectionData.uniquePricingMap,
    transparentPricingSectionData.variantIdToUniqueMap,
  )

  if (shouldHideTransparentPricing(props.product)) return null
  return (
    <div className={styles.transparentPricing}>
      {isB2BMode && <B2BDivider />}
      <TransparentPricingC
        items={buildTransparentPricingItems(costsForVariant, t)}
        quincePrice={quincePrice}
        traditionalPrice={traditionalPrice || 0}
      />
    </div>
  )
}

export default TransparentPricingProduct
